<template lang="pug">
  .center
    section.custom-width.margin-top
      el-row(:gutter="16")
        el-col(:span="24")
          h5.text-primary O que fazemos
          h2
            |Construindo experiências digitais
            span.space
            span.text-secondary duradouras
      el-row.card-margin(:gutter="16")
          el-col.margin(:xs="24", :sm="8", :md="8", data-aos="fade-up", data-aos-delay="200")
            el-card(shadow="hover", :body-style="{backgroundColor: $root.cPrimary, color: 'white'}")
              el-row(:gutter="16")
                el-col(:span="6")
                  h1
                    bar-graph(:style="{fill: 'white'}")
                el-col(:span="18")
                  h3 Estrategia e Gestão
                  p 
          el-col.margin(:xs="24", :sm="8", :md="8", data-aos="fade-up", data-aos-delay="250")
            el-card(shadow="hover", :body-style="{color: $root.cPrimary}")
              el-row(:gutter="16")
                el-col(:span="6")
                  h1
                    rocket(:style="{fill: '#184C78'}")
                el-col(:span="18")
                  h3 Lançamento
                  p Cuidamos de todos os processos para lançamentos digitais, desde a copy a captação de leads.
          el-col.margin(:xs="24", :sm="8", :md="8", data-aos="fade-up", data-aos-delay="500")
            el-card(shadow="hover", :body-style="{backgroundColor: $root.cPrimary, color: 'white'}")
              el-row(:gutter="16")
                el-col(:span="6")
                  h1
                    trophy(:style="{fill: 'white'}")
                el-col(:span="18")
                  h3 Otimização
                  p Trabalhamos para ter bons resultados e sempre de olho no ranqueamento, trabalhamos com as melhores tecnicas de SEO, prezamos por um design de qualidade resultando em um profissionalismo e exlusivo.
</template>

<script>
import Rocket from 'vue-entypo-icons/lib/Rocket'
import Trophy from 'vue-entypo-icons/lib/Trophy'
import BarGraph from 'vue-entypo-icons/lib/BarGraph'

export default {
  name: 'what-we-do',
  components: {
    Rocket,
    BarGraph,
    Trophy
  }
}
</script>

<style lang="sass" scoped>
  @import '../../assets/sass/bootloader'
  h5
    font-size: $f-size*1.1
  h1
    font-size: $f-size*2.4
  h3
    font-size: $f-size*1.2
  .card-margin
    margin: 64px 0
    @media (max-width: 767px)
      margin: 16px 0
  .margin
    margin-bottom: 16px
</style>